import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const ViewerStartupsTab = ({ startups, startupsPagination, startupsCurrentPage, setStartupsCurrentPage }) => {
	const navigate = useNavigate();
	const { tenantId } = useParams();

	return (
		<div className="p-6 flex flex-col" style={{ height: 'calc(100vh - 140px)' }}>
			<div className="flex justify-between items-center mb-6">
				<h2 className="text-xl font-semibold text-gray-900">Startups</h2>
			</div>

			<div className="flex-1 overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg mb-6">
				<table className="min-w-full divide-y divide-gray-300">
					<thead className="bg-gray-50 sticky top-0">
						<tr>
							<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Startup
							</th>
							<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Industry
							</th>
							<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Category
							</th>
							<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Stage
							</th>
							<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Address
							</th>
							<th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Status
							</th>
						</tr>
					</thead>
					<tbody className="bg-white divide-y divide-gray-200">
						{startupsPagination.currentStartups.map((startup) => (
							<tr
								key={startup.id}
								onClick={() => navigate(`/${tenantId}/startups/${startup.id}`)}
								className="hover:bg-gray-50 cursor-pointer"
							>
								<td className="px-4 py-3 whitespace-nowrap">
									<div className="flex items-center">
										<div className="flex-shrink-0 h-10 w-10">
											<div className="h-10 w-10 rounded-full bg-gradient-to-r from-green-500 to-green-600 flex items-center justify-center">
												<span className="text-white font-medium">
													{(startup.organizationName || startup.name)?.charAt(0)?.toUpperCase()}
												</span>
											</div>
										</div>
										<div className="ml-4">
											<div className="text-sm font-medium text-gray-900">{startup.organizationName || 'Not specified'}</div>
											<div className="text-sm text-gray-500">{startup.name}</div>
										</div>
									</div>
								</td>
								<td className="px-4 py-3 whitespace-nowrap">
									<div className="text-sm text-gray-900">{startup.industry || 'Not specified'}</div>
								</td>
								<td className="px-4 py-3 whitespace-nowrap">
									<div className="text-sm text-gray-900">{startup.organizationType || 'Not specified'}</div>
								</td>
								<td className="px-4 py-3 whitespace-nowrap">
									<div className="text-sm text-gray-900">{startup.stage || 'Not specified'}</div>
								</td>
								<td className="px-4 py-3 whitespace-nowrap">
									<div className="text-sm text-gray-900">{startup.address || 'Not specified'}</div>
								</td>
								<td className="px-4 py-3 whitespace-nowrap">
									<span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
										Active
									</span>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			{/* Fixed Bottom - Pagination */}
			<div className="bg-white border-t border-gray-200 py-2 px-4 rounded-lg shadow">
				<div className="flex items-center justify-between">
					<div className="text-sm text-gray-700">
						Showing <span className="font-medium">{startupsPagination.startIndex + 1}</span> to <span className="font-medium">{Math.min(startupsPagination.endIndex, startups.length)}</span> of <span className="font-medium">{startups.length}</span> startups
					</div>
					{startupsPagination.totalPages > 1 && (
						<div className="flex items-center space-x-2">
							<button
								onClick={() => setStartupsCurrentPage(startupsCurrentPage - 1)}
								disabled={startupsCurrentPage === 1}
								className="px-3 py-1 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
							>
								Previous
							</button>
							<div className="flex items-center space-x-1">
								{[...Array(startupsPagination.totalPages)].map((_, index) => {
									const page = index + 1;
									if (
										page === 1 ||
										page === startupsPagination.totalPages ||
										(page >= startupsCurrentPage - 1 && page <= startupsCurrentPage + 1)
									) {
										return (
											<button
												key={page}
												onClick={() => setStartupsCurrentPage(page)}
												className={startupsCurrentPage === page
													? 'px-3 py-1 rounded-md text-sm font-medium bg-blue-600 text-white'
													: 'px-3 py-1 rounded-md text-sm font-medium border border-gray-300 text-gray-700 hover:bg-gray-50'}
											>
												{page}
											</button>
										);
									} else if (page === startupsCurrentPage - 2 || page === startupsCurrentPage + 2) {
										return <span key={page} className="px-2 text-gray-500">...</span>;
									}
									return null;
								})}
							</div>
							<button
								onClick={() => setStartupsCurrentPage(startupsCurrentPage + 1)}
								disabled={startupsCurrentPage === startupsPagination.totalPages}
								className="px-3 py-1 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
							>
								Next
							</button>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default ViewerStartupsTab;

